import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {SystemNotificationsService} from '../../services/system-notifications.service';
import {SystemNotificationModel} from '../../models/system-notification.model';

@Component({
  selector: 'app-system-notifications',
  templateUrl: './system-notifications.component.html',
  styleUrls: ['./system-notifications.component.css']
})
export class SystemNotificationsComponent implements OnInit, OnDestroy {
  selectedLanguageSubscription: Subscription;
  systemNotificationsSubscription: Subscription;
  notification: SystemNotificationModel;
  show: boolean;

  constructor(
    private systemNotificationsService: SystemNotificationsService
  ) {
  }

  ngOnInit(): void {
    this.onSubscribeToShowNotification();
  }

  onSubscribeToShowNotification(): void {
    this.systemNotificationsSubscription = this.systemNotificationsService.systemNotificationsSubject.subscribe((notification) => {
      if (notification) {
        this.show = true;
        this.notification = notification;

        setTimeout(() => {
          // this.onHide();
        }, 3000);
      } else {
        this.onHide();
      }
    });
  }

  onHide(): void {
    this.show = false;
  }

  ngOnDestroy(): void {
    if (this.selectedLanguageSubscription) {
      this.selectedLanguageSubscription.unsubscribe();
    }
    if (this.systemNotificationsSubscription) {
      this.systemNotificationsSubscription.unsubscribe();
    }
  }
}
